import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('cop_token');
  const sessionToken = sessionStorage.getItem('cop_session_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (sessionToken) config.headers['X-Session-Token'] = sessionToken;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const msg = error.response?.data?.detail || '';
      if (msg.includes('another device') || msg.includes('expired') || msg.includes('Invalid token')) {
        localStorage.removeItem('cop_token');
        sessionStorage.removeItem('cop_session_token');
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
